import { Table, TableBody, TableCell, TableHead, TableRow, Grid, Paper } from '@mui/material';
import { makeStyles } from '@mui/styles';
import Button from '../../UI/Button';
import { dateFormat } from '../../../util/DateUtil';
import Loading from '../../UI/Loading';

const useStyles = makeStyles({
    container: {
        padding: '10px',
    },
});

const DiaLetivoExtraSerieTable = ({
    listDiaLetivoExtraSerie,
    isLoading,
    setIsAdding,
    handleRemove,
    isLoadingAction
}) => {
    const classes = useStyles();
    return (
        <Grid
            container
            component={Paper}
            className={classes.container}
        >
            <Button
                disabled={isLoadingAction}
                onClick={() => setIsAdding(true)}
            >
                Novo Dia Letivo Extra Série
            </Button>
            {isLoading ?
                <Grid
                    container
                    justifyContent='center'
                >
                    <Loading description="Carregando Dias não Letivo" />
                </Grid>
                :
                <Table size="small" aria-label="a dense table">
                    <TableHead>
                        <TableRow>
                            <TableCell>Data</TableCell>
                            <TableCell>Descrição</TableCell>
                            <TableCell>Ações</TableCell>
                        </TableRow>
                    </TableHead>
                    <TableBody>
                        {listDiaLetivoExtraSerie.map((diaLetivoExtraSerie) => (
                            <TableRow key={diaLetivoExtraSerie.codigo}>
                                <TableCell>{dateFormat(diaLetivoExtraSerie.diaLetivoExtra.data)}</TableCell>
                                <TableCell>{diaLetivoExtraSerie.diaLetivoExtra.descricao}</TableCell>
                                <TableCell>
                                    <Button
                                        onClick={() => handleRemove(diaLetivoExtraSerie.codigo)}
                                    >
                                        Remover
                                    </Button>
                                </TableCell>

                            </TableRow>
                        ))}
                    </TableBody>
                </Table>
            }

        </Grid>
    )
}

export default DiaLetivoExtraSerieTable;